export type GuardTone = "destructive" | "warning";

/** Paleta compartilhada entre o painel de guarda e o fundo animado. */
export const GUARD_TONES: Record<GuardTone, { halo: string; badge: string; icon: string }> = {
  destructive: {
    halo: "bg-destructive/20",
    badge: "bg-destructive/10 ring-destructive/25",
    icon: "text-destructive",
  },
  warning: {
    halo: "bg-amber-500/20",
    badge: "bg-amber-500/10 ring-amber-500/25",
    icon: "text-amber-500",
  },
};
